import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Details from './Details'
import List from './Table'

import './style.scss'

class NewSaleOrdersRouter extends Component {
  render() {
    const { router, ...props } = this.props
    const details = { ...props }
    details.url = '/customer-support'
    details.className = 'cx-listing'
    if (router.match.params.id) {
      return <Details {...details} />
    }
    return <List {...this.props} />
  }
}

export default withRouter(({ match, ...props }) => (
  <NewSaleOrdersRouter router={{ match }} {...props} />
))
